import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles({
	input: {
		flex: '1 1 85%',
		margin: 0,
	},
});
